export var TopAmenityEnum;
(function (TopAmenityEnum) {
    TopAmenityEnum["Restaurant"] = "Restaurant";
    TopAmenityEnum["FreeWifi"] = "FreeWifi";
    TopAmenityEnum["ParkingIncluded"] = "ParkingIncluded";
    TopAmenityEnum["TwentyFourSevenFrontDesk"] = "TwentyFourSevenFrontDesk";
    TopAmenityEnum["Pool"] = "Pool";
    TopAmenityEnum["Bar"] = "Bar";
    TopAmenityEnum["PetFriendly"] = "PetFriendly";
    TopAmenityEnum["BusinessServices"] = "BusinessServices";
    TopAmenityEnum["AirportShuttle"] = "AirportShuttle";
    TopAmenityEnum["Laundry"] = "Laundry";
    TopAmenityEnum["Spa"] = "Spa";
    TopAmenityEnum["Gym"] = "Gym";
    TopAmenityEnum["Accessibility"] = "Accessibility";
    TopAmenityEnum["AdultsOnly"] = "AdultsOnly";
    TopAmenityEnum["BreakfastAvailable"] = "BreakfastAvailable";
    TopAmenityEnum["ParkingAvailable"] = "ParkingAvailable";
})(TopAmenityEnum || (TopAmenityEnum = {}));
export var AirlineOpenEnum;
(function (AirlineOpenEnum) {
    AirlineOpenEnum["AA"] = "AA";
    AirlineOpenEnum["B6"] = "B6";
    AirlineOpenEnum["DL"] = "DL";
    AirlineOpenEnum["ExcludeLcc"] = "ExcludeLcc";
    AirlineOpenEnum["F9"] = "F9";
    AirlineOpenEnum["NK"] = "NK";
    AirlineOpenEnum["UA"] = "UA";
})(AirlineOpenEnum || (AirlineOpenEnum = {}));
export var UserPreferenceKeyEnum;
(function (UserPreferenceKeyEnum) {
    UserPreferenceKeyEnum["hasSeenStaysVrFtux"] = "hasSeenStaysVrFtux";
    UserPreferenceKeyEnum["hasSeenWishlistsFtux"] = "hasSeenWishlistsFtux";
    UserPreferenceKeyEnum["hasSeenStayTypeVrFtux"] = "hasSeenStayTypeVrFtux";
    UserPreferenceKeyEnum["hasSeenPackagesFtux"] = "hasSeenPackagesFtux";
    UserPreferenceKeyEnum["hasSeenActivitiesFtux"] = "hasSeenActivitiesFtux";
    UserPreferenceKeyEnum["hasAnsweredActivitiesSurvey"] = "hasAnsweredActivitiesSurvey";
    UserPreferenceKeyEnum["lastSeenActivitiesSurvey"] = "lastSeenActivitiesSurvey";
    UserPreferenceKeyEnum["userHasVisitedActivityShopPage"] = "userHasVisitedActivityShopPage";
    UserPreferenceKeyEnum["creditCampaignFtux"] = "creditCampaignFtux";
    UserPreferenceKeyEnum["hasSeenTravelAppFtux"] = "hasSeenTravelAppFtux";
    UserPreferenceKeyEnum["hasSeenMyTripsCsatSurveyV1"] = "hasSeenMyTripsCsatSurveyV1";
    UserPreferenceKeyEnum["hasSubmittedPayFlexSurvey"] = "hasSubmittedPayFlexSurvey";
    UserPreferenceKeyEnum["hasSubmittedCarsTripProtectionSurvey"] = "hasSubmittedCarsTripProtectionSurvey";
    UserPreferenceKeyEnum["hasSubmittedFlightsTripProtectionSurvey"] = "hasSubmittedFlightsTripProtectionSurvey";
    UserPreferenceKeyEnum["hasSeenTripsReplatformBanner"] = "hasSeenTripsReplatformBanner";
})(UserPreferenceKeyEnum || (UserPreferenceKeyEnum = {}));
//# sourceMappingURL=user-preferences.js.map